<template>
	<div class="new-tasklist-wrapper">
		<div class="new-tasklist elevation-1 background-2 round-card">
			<v-col cols="12" align-self="center" v-if="!showInput">
				<v-btn fab small dark color="red" @click="showInput = !showInput" style="margin-bottom: auto; margin-top: auto; width: 48px; height: 48px">
					<v-icon dark>mdi-plus</v-icon>
				</v-btn>
				<span class="pl-2">Aggiungi</span>
			</v-col>
			<div v-else style="flex: 1 0 auto; box-sizing: border-box; flex-direction: row; display: flex;">
                <v-text-field
                    name="Titolo"
                    label="Titolo"
                    v-model="model['name']"
                    class="fw500"
                    style="margin: auto"
                    :background-color="$vuetify.theme.dark ? 'background-2' : 'background-2'"
                    single-line
                    flat
					solo
                    autofocus
                    hide-details
                    @keyup.enter="storeTasklist()"
                ></v-text-field>
			    <v-btn icon small text :loading="saving" :disabled="canSave" @click="storeTasklist()" style="margin: auto;">
			        <v-icon>check</v-icon>
			    </v-btn>
			    <v-btn icon small text @click="showInput = !showInput" style="margin: auto;">
			        <v-icon>close</v-icon>
			    </v-btn>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'add-tasklist',
	components: {
			
	},
	data() {
		return {
			showInput: false,
			defaultModel: {'listable_type': this.listableType, 'listable_id': this.listableId, 'name': ''},
			model: {'listable_type': this.listableType, 'listable_id': this.listableId, 'name': ''},
			saving: false,
		}
	},

	props: {
		listableType: {
			type: String,
			required: true
		},
		listableId: {
			type: Number,
			required: true
		},
	},
        
	computed: {
		canSave() {
			return !(this.model.name && this.model.name.length > 0) 
		}
	},

	methods: {
		storeTasklist() {
			if(!this.canSave) {
				this.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}
					this.saving = true
					this.axios.post('tasklists/', this.model).then(response => {
						// get body data
						this.model = Object.assign(this.model, this.defaultModel)
						this.$eventBusUtility.$emit('initializeTaskboard')
						this.showInput = false
						this.saving = false
					},
					response => {
						// error callback
					})
				})
					.catch(() => {
    
					})
			}
		}
	},

	created() {

	}
}
</script>
<style>
	.new-tasklist-wrapper {
	    width: 344px;
	    min-width: 344px;
	    max-width: 344px;
	    padding-right: 24px;
        border-radius: 2px;
	}
    
	.new-tasklist {
	    height: 64px;
	    min-height: 64px;
	    padding: 0 8px 0 16px;
        flex-direction: row;
        box-sizing: border-box;
        display: flex;
	}

</style>